import { RootState } from '..';

export const selectCircles = (state: RootState) => state.nextcloud.circles;
export const selectShares = (state: RootState) => state.nextcloud.shares;
